import React from 'react';
import { FlexCenter } from '../../../../layout/FlexCenter/FlexCenter';
import { ComboSelect } from '../../../../../constants/constants';
import { SpacingCustom } from '../../../../layout/Spacing/SpacingCustom';
import { Combo } from '../../../../shared/Combo/Combo';

export const ConflictCategoryDropDown = () => {
    const onChange = (value: string) => {
        // eslint-disable-next-line no-console
        console.log(value);
    };

    return (
        <FlexCenter direction="h" position="start" gap={0.5}>
            <SpacingCustom paddingBottom={0.5} />
            <Combo options={ComboSelect.CONFLICT_CATEGORY} onChange={onChange} />
        </FlexCenter>
    );
};
